import { useEffect, useState } from "react";

import {
  EPISODE_DETAIL_INCLUDE,
  getEpisodeDetailData,
} from "@/api/endpoints/channels";
import { ChannelDetailEpisode } from "@/types/Channel";
import SpinnerAnimated from "@components/SpinnerAnimated";

const EpisodeMentionCount: React.FunctionComponent<{ id: string }> = ({
  id,
}) => {
  // This component is only responsible for getting the mention count
  // for an episode. This enables making this slow count async.

  const [loading, setLoading] = useState<boolean>(false);
  const [episode, setEpisode] = useState<ChannelDetailEpisode>();

  // Get mention count from episode details endpoint
  useEffect(() => {
    setLoading(true);
    getEpisodeDetailData(id, [EPISODE_DETAIL_INCLUDE.MENTION_COUNT])
      .then((response) => {
        if (response.ok && response.data) {
          setEpisode(response.data);
        } else {
          throw new Error(response.statusText);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  return (
    <div>
      {loading && !episode ? (
        <SpinnerAnimated fill="currentColor" width="2rem" />
      ) : (
        episode?.mention_count
      )}
    </div>
  );
};

export default EpisodeMentionCount;
